import React from 'react';
import { Box, Typography } from '@mui/material';
import './AdminPageHeader.css';

const AdminPageHeader = ({ eyebrow, title, subtitle, icon, action }) => (
  <Box className="admin-page-header">
    <Box className="admin-page-header__main">
      <Box className="admin-page-header__icon">{icon}</Box>
      <Box>
        <Typography className="admin-page-header__eyebrow">{eyebrow}</Typography>
        <Typography variant="h4" className="admin-page-header__title">{title}</Typography>
        {subtitle && (
          <Typography className="admin-page-header__subtitle">{subtitle}</Typography>
        )}
      </Box>
    </Box>
    {action && <Box className="admin-page-header__action">{action}</Box>}
  </Box>
);

export default AdminPageHeader;
